export default "__VITE_ASSET__CV_HQr0a__"